import { render, staticRenderFns } from "./disRes.vue?vue&type=template&id=ea04cabc&scoped=true&"
import script from "./disRes.vue?vue&type=script&lang=js&"
export * from "./disRes.vue?vue&type=script&lang=js&"
import style0 from "./disRes.vue?vue&type=style&index=0&id=ea04cabc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea04cabc",
  null
  
)

export default component.exports